import {Component, Inject, ViewEncapsulation} from '@angular/core';
import * as de from '../../translations/de';
import {CoreSettings} from '../../models/settings/core.settings';
import {SETTINGS} from '../../models/settings/settings';
import {Language} from '../../models/settings/core.settings';
import {DeviceService} from '../../services/device.service';
import {TranslationService} from '../../services/translation.service';

@Component({
    selector: 'lv-browserwarning',
    templateUrl: './browserWarning.component.html',
    styleUrls: ['./browserWarning.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BrowserWarningComponent {

  public isMac: string;

  constructor(translationService: TranslationService, @Inject(SETTINGS) _settings: CoreSettings,
              deviceService: DeviceService) {
    translationService.addTranslations(Language.DE, de.translations);
    translationService.useLanguage(_settings.translationLanguage, Language.DE);
    if (deviceService.isMacOsDevice) {
      this.isMac = 'lv-is-mac';
    }
  }
}
